import React, { Component, Fragment } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Carousel as GenericCarousal } from '../../Generic/Carousel';
import { getCard, getBanner, getImage, getContentImageSet } from '../../../utils/uiHelper';
import getWidth from '../../../utils/gridWidth';
import i18nMessages from '../../../constants/messages/pt-BR';
import CarouselPanel from './CarouselPanel';
import CarouselSetting from './CarouselSetting';
import { VideoCarousel } from '../VideoCard';
import VideoBanner from '../VideoBanner/VideoBanner';
import Typography from '../../Generic/Typography';
import ProductCard from '../ProductCard/ProductCard';
import style from '../ProductCard/ProductCard-tw-styles';

export class Carousel extends Component {

   constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
    };
  }

  componentDidMount() {
    const isMobile = window.innerWidth < 768;
    this.setState({
      isMobile: isMobile,
    });
  }

  render() {
    const { carousel } = this.props;
     const { isMobile } = this.state;

    const widthClass = getWidth(carousel.componentWidth);
    const carouselStyle = carousel.styles && carousel.styles.trim();
    let carouselSetting = CarouselSetting.carouselHome;
    if (carouselStyle && CarouselSetting[carouselStyle] !== undefined) {
      carouselSetting = CarouselSetting[carouselStyle];
    }
 if (carouselStyle === 'jamieCollectionPDP' && isMobile) {
      carouselSetting = { ...carouselSetting, slidesToShow: 1.2 };
    }
    // background image for the carousel container
    if(carousel?.bgImage != null) {
      var backgroundStyle = {
        backgroundImage: isMobile ? 'url(' + carousel?.bgImage?.smartphoneImage?.url + ')' :'url(' + carousel?.bgImage?.desktopImage?.url + ')' ,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      };

    }

    return (
      <Fragment>
        <div className={classNames(widthClass)}
         style={carousel?.bgImage != null ? backgroundStyle: { backgroundColor: 'transparent' }}
         >
      {
        carousel?.sectionTitle &&
           <Typography
              component="div"
              className={style.sectionTitle}
              dangerouslySetInnerHTML={
                carousel?.sectionTitle && {
                  __html: DOMPurify.sanitize(carousel?.sectionTitle),
                }
              }
            />
      }

       {
        carousel?.description &&
           <Typography
              component="div"
              className={style.subTitle}
              dangerouslySetInnerHTML={
                carousel?.description && {
                  __html: DOMPurify.sanitize(carousel?.description),
                }
              }
            />
      }
          <div className={carouselStyle === "jamieCollectionPDP" ? style.carouselTop : style.carouselTopImage}>
          <GenericCarousal {...carouselSetting}>
            {carousel &&
              carousel.carouselPanelsCollection &&
              carousel.carouselPanelsCollection.items.map((panelData,i) => {
                if (panelData) {
                  switch (panelData.__typename) {
                    case i18nMessages.Callout: {
                      return getCard({
                        ...panelData,
                      });
                    }
                    case i18nMessages.Banner: {
                      return getBanner(panelData);
                    }

                    case i18nMessages.Carousel: {
                      return <CarouselPanel panel={panelData} />;
                    }
                    case i18nMessages.Image: {
                      return getImage(panelData);
                    }
                    case i18nMessages.ImageSet: {
                      return getContentImageSet(panelData);
                    }
                    case i18nMessages.VideoCard: {
                      return <VideoCarousel data={panelData} />;
                    }
                    case i18nMessages.VideoBanner: {
                      return <VideoBanner data={panelData} />;
                    }
                    case i18nMessages.ProductCard: {
                      return <ProductCard data={panelData} key={i} />;
                    }

                    default:
                      return null;
                  }
                }
              })}
          </GenericCarousal>
        </div>

          {
            carousel?.disclaimer &&
              <Typography
                  component="div"
                  className={style.disclaimer}
                  dangerouslySetInnerHTML={
                    carousel?.disclaimer && {
                      __html: DOMPurify.sanitize(carousel?.disclaimer),
                    }
                  }
                />
          }
        </div>
      </Fragment>
    );
  }
}

Carousel.propTypes = {
  carousel: PropTypes.oneOfType([PropTypes.object]).isRequired,
  videoClickEvent: PropTypes.func,
};

Carousel.defaultProps = {
  videoClickEvent: () => {},
};

export default Carousel;
